import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import SessionManager from "@/apollo/datasources/sessionManager";
import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
import Cookies from "@/lib/cookies";
import dayjs from "@/lib/day";
import { AuthenticationError } from "apollo-server-errors";
import { createHash } from "crypto";
import jwt from "jsonwebtoken";

var UserToken = /*#__PURE__*/function () {
  function UserToken(req, res) {
    var _config$token$redis, _config$token$redis2, _config$token$redis3, _config$token, _config$token$redis4;

    _classCallCheck(this, UserToken);

    this.req = req;
    this.res = res;
    this.adultMode = req.adultMode;
    this.cookies = new Cookies(req, res);
    this.redis = connectRedis({
      host: process.env.REDIS_HOST || ((_config$token$redis = config.token.redis) === null || _config$token$redis === void 0 ? void 0 : _config$token$redis.host),
      port: process.env.REDIS_PORT || ((_config$token$redis2 = config.token.redis) === null || _config$token$redis2 === void 0 ? void 0 : _config$token$redis2.port),
      keyPrefix: config.token.redis.prefix,
      db: (_config$token$redis3 = config.token.redis) === null || _config$token$redis3 === void 0 ? void 0 : _config$token$redis3.db
    }, (_config$token = config.token) === null || _config$token === void 0 ? void 0 : (_config$token$redis4 = _config$token.redis) === null || _config$token$redis4 === void 0 ? void 0 : _config$token$redis4.cluster);
  }

  _createClass(UserToken, [{
    key: "cookieName",
    get: function get() {
      if (this.adultMode) return "".concat(config.token.name, "-ex");
      return config.token.name;
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return this.cookies.get(this.cookieName);
    }
  }, {
    key: "signatureName",
    get: function get() {
      if (this.adultMode) return "".concat(config.token.signature, "-ex");
      return config.token.signature;
    }
  }, {
    key: "getSignature",
    value: function getSignature() {
      return this.cookies.get(this.signatureName);
    }
  }, {
    key: "getSecret",
    value: function getSecret() {
      var signature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!signature) {
        signature = this.getSignature();
      }

      return "".concat(signature).concat(config.token.secret);
    }
  }, {
    key: "generateKey",
    value: function generateKey(id, signature) {
      var _this = this;

      var key = function () {
        if (_this.adultMode) return "token:".concat(id, ":ex:").concat(signature);
        return "token:".concat(id, ":").concat(signature);
      }();

      return createHash("sha256").update(key).digest("hex");
    }
  }, {
    key: "setPayload",
    value: function () {
      var _setPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload, signature) {
        var key;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                key = this.generateKey(payload.id, signature);
                _context.next = 3;
                return this.redis.multi().set(key, JSON.stringify(payload)).expire(key, config.token.maxAge).exec();

              case 3:
                return _context.abrupt("return", key);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setPayload(_x, _x2) {
        return _setPayload.apply(this, arguments);
      }

      return setPayload;
    }()
  }, {
    key: "getPayload",
    value: function () {
      var _getPayload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var json;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.redis.get(key);

              case 2:
                json = _context2.sent;
                return _context2.abrupt("return", JSON.parse(json));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getPayload(_x3) {
        return _getPayload.apply(this, arguments);
      }

      return getPayload;
    }()
  }, {
    key: "deletePayload",
    value: function deletePayload(key) {
      return this.redis.del(key);
    }
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload, signature) {
        var key, secret, token, options;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!signature) {
                  signature = this.getSignature();
                }

                _context3.next = 3;
                return this.setPayload(payload, signature);

              case 3:
                key = _context3.sent;
                secret = this.getSecret(signature);
                token = jwt.sign({
                  key: key
                }, secret);
                options = {
                  maxAge: config.token.maxAge
                }; // remembermeのon/offがあったらこっちにする
                // let options = {};
                // if (payload.rememberme) {
                //   options = {
                //     maxAge: config.token.maxAge,
                //   };
                // }

                this.cookies.set([{
                  name: this.signatureName,
                  value: signature,
                  options: options
                }, {
                  name: this.cookieName,
                  value: token,
                  options: options
                }]);
                return _context3.abrupt("return", token);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function sign(_x4, _x5) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "refreshToken",
    value: function () {
      var _refreshToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var sessionManager, ret;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                sessionManager = new SessionManager({
                  req: this.req,
                  res: this.res
                });
                _context4.next = 4;
                return sessionManager.tokenRefresh();

              case 4:
                ret = _context4.sent;
                return _context4.abrupt("return", {
                  accessToken: ret.access_token,
                  refreshToken: ret.refresh_token,
                  tokenExpiredAt: dayjs().add(ret.expires_in, "second").format()
                });

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                // if (e instanceof AuthenticationError) {
                //   if (token.payload.rememberme) {
                //     const rememberme = new Rememberme();
                //     const remembermeData = await rememberme.get(token.payload.id);
                //     if (remembermeData) {
                //       const user = new User();
                //       user.initialize({ context: { req: this.req, res: this.res } });
                //       const ret = await user.login(
                //         remembermeData.loginid,
                //         remembermeData.password
                //       );
                //       rememberme.refresh(token.payload.id);
                //       return {
                //         accessToken: ret.access_token,
                //         refreshToken: ret.refresh_token,
                //         tokenExpiredAt: dayjs().add(ret.expires_in, "second").format(),
                //       };
                //     }
                //   }
                // }
                console.log("tokenRefresh Error:", _context4.t0);
                console.log(_context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.extension);
                this.delete();
                throw new AuthenticationError("Unauthorized");

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));

      function refreshToken() {
        return _refreshToken.apply(this, arguments);
      }

      return refreshToken;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var updatePayload,
            token,
            refreshPayload,
            newPayload,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                updatePayload = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                _context5.next = 3;
                return this.verify();

              case 3:
                token = _context5.sent;

                if (token) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return", null);

              case 6:
                delete token.iat;
                delete token.exp;
                delete token.nbf;
                delete token.jti; // アクセストークンのexpireが近かったらリフレッシュする

                refreshPayload = {};

                if (! // tokenが発行した時刻から15分以上経過していればリフレッシュする
                dayjs(token.payload.tokenExpiredAt).isBefore(dayjs().add(15, "minutes"))) {
                  _context5.next = 15;
                  break;
                }

                _context5.next = 14;
                return this.refreshToken();

              case 14:
                refreshPayload = _context5.sent;

              case 15:
                newPayload = Object.assign({}, token.payload, updatePayload, refreshPayload);
                _context5.next = 18;
                return this.sign(newPayload);

              case 18:
                return _context5.abrupt("return", newPayload);

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var token, secret, verifiedToken, payload;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // cookieからtokenを取得
                token = this.getToken();

                if (token) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return", false);

              case 3:
                // cookieからsignatureを取得
                secret = this.getSecret(); // tokenを検証

                verifiedToken = jwt.verify(token, secret); // redisからpayloadを取得

                _context6.next = 7;
                return this.getPayload(verifiedToken.key);

              case 7:
                payload = _context6.sent;

                if (payload) {
                  _context6.next = 10;
                  break;
                }

                return _context6.abrupt("return", false);

              case 10:
                return _context6.abrupt("return", _objectSpread(_objectSpread({}, verifiedToken), {}, {
                  payload: payload
                }));

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function verify() {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var token, secret, verifiedToken;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                token = this.getToken();

                if (token) {
                  _context7.next = 4;
                  break;
                }

                console.log("userToken delete, token not found");
                return _context7.abrupt("return", false);

              case 4:
                _context7.prev = 4;
                secret = this.getSecret();
                verifiedToken = jwt.verify(token, secret);
                _context7.next = 9;
                return this.deletePayload(verifiedToken.key);

              case 9:
                _context7.next = 14;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](4);
                console.log("token delete error", _context7.t0);

              case 14:
                _context7.prev = 14;
                this.cookies.remove([this.cookieName, this.signatureName, [config.optionalTermsConfirmCookieName, {
                  domain: null
                }]]);
                return _context7.finish(14);

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 11, 14, 17]]);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "deleteAll",
    value: function () {
      var _deleteAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this2 = this;

        var removeCookies;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                removeCookies = [config.adultRestrictedCookie.name, config.adultConfirmCookieName, [config.optionalTermsConfirmCookieName, {
                  domain: null
                }]];

                try {
                  [true, false].forEach( /*#__PURE__*/function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(val) {
                      var token, secret, verifiedToken;
                      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              _this2.adultMode = val;
                              token = _this2.getToken();

                              if (!token) {
                                _context8.next = 9;
                                break;
                              }

                              secret = _this2.getSecret();
                              verifiedToken = jwt.verify(token, secret);
                              removeCookies.push(_this2.cookieName);
                              removeCookies.push(_this2.signatureName);
                              _context8.next = 9;
                              return _this2.deletePayload(verifiedToken.key);

                            case 9:
                            case "end":
                              return _context8.stop();
                          }
                        }
                      }, _callee8);
                    }));

                    return function (_x6) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                } catch (e) {
                  console.log("token delete error", e);
                } finally {
                  this.cookies.remove(removeCookies);
                }

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function deleteAll() {
        return _deleteAll.apply(this, arguments);
      }

      return deleteAll;
    }()
  }]);

  return UserToken;
}();

export { UserToken as default };